import React from "react";
import { Avatar, Box, Paper, Typography } from "@material-ui/core";
import { LockOutlined, PermIdentityOutlined, PhoneOutlined, VpnKeyOutlined } from "@material-ui/icons";
import DetailRow from "./DetailRow";
import useStyles from "./detailStyles";

export default function ParticipantDetails({ owner, privacyMode }) {
  const classes = useStyles();
  const name = privacyMode ? "شرکت‌کننده" : owner?.fullName || "کاربر حذف شده";
  const personnel = owner?.personnelCode;
  const displayedPersonnel = personnel == null ? "—" : privacyMode ? `**${String(personnel).slice(2)}` : personnel;
  const personalInfo = value => privacyMode ? "—" : value || "—";
  return <Paper component="section" aria-label="جزئیات کاربر" elevation={0} className={classes.panel}>
    <Box className={classes.panelHeading}><Typography component="h3" className={classes.heading}><PermIdentityOutlined />جزئیات کاربر</Typography></Box>
    <Box className={classes.participant}><Avatar className={classes.avatar} aria-hidden="true">{name.trim().charAt(0)}</Avatar>
      <Box><Typography className={classes.participantName}>{name}</Typography>{privacyMode && <Typography className={classes.privacy}><LockOutlined />اطلاعات شخصی پنهان است</Typography>}</Box>
    </Box>
    <Box component="dl" className={classes.details}>
      <DetailRow label="کد پرسنلی" icon={<VpnKeyOutlined />}>{displayedPersonnel}</DetailRow>
      <DetailRow label="کد ملی" icon={<PermIdentityOutlined />}>{personalInfo(owner?.nationalCode)}</DetailRow>
      <DetailRow label="شماره تماس" icon={<PhoneOutlined />}>{personalInfo(owner?.phone)}</DetailRow>
    </Box>
  </Paper>;
}
